export default __webpack_public_path__ + "static/media/museum-logo-white.4a6927ac.svg";